export function addPercentageField(result) {
    let total = 0;
    result.forEach(function (item) {
        total = total + item.value;
    });
    result.forEach(function (item) {
        item.percentage = ((item.value / total) * 100).toFixed(2).toString().concat("%");
    });
    return result;
}

export function addThousandSeparator(value = "") {
    const valueString = value.toString();
    const x = valueString.split(".");
    let x1 = x[0];
    const x2 = x.length > 1 ? "." + x[1] : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1,$2");
    }
    return x1.concat(x2);
  }